module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/R4ntHq/tc-custom/9781609252359.jpg?1721404571073",
      "alt": "This image is the cover for the book Twenty-Five Doors to Meditation"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Twenty-Five Doors to Meditation\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("An indispensable reference for individuals searching for the meditation technique that is best for them.")]), _c('br'), _c('br'), _c('i', [_vm._v("Twenty-Five Doors to Meditation")]), _vm._v(" is the first guide to provide extensive, comprehensive, and detailed information about a variety of meditation methods. Together, William Bodri and Lee Shu-Mei make sense of the seemingly conflicting information that exists today regarding the path to spiritual enlightenment. Each meditation technique is fully described as is the interrelationship between the different paths to enlightenment."), _c('br'), _c('br'), _vm._v("The authors show how Buddhist techniques can be explained through Taoist principles, Christian techniques through Hindu principles, and so on. Each meditation technique is designed to help you attain samadhi, the crux of spiritual development. The authors explore the scientific basis behind each technique, developmental stages of accomplishment, and each path’s effectiveness for entering samadhi. Especially useful is an extensive list of recommended references for the further study of individual techniques.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      William Bodri, Lee Shu-Mei\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("William Bodri is an interfaith consultant who has developed an expertise in Asian philosophy. He has degrees in Engineering, Business Strategy, and Nutrition. He is the co-author of 25 Doors to Meditation.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Samuel Weiser\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0